import { TradeOrderInfoPanel, type TradeOrderData } from "../TradeOrderComponentPrimitives";
import type { DeliveryVo } from "@zhihaoscm/entity";
import ProductDetailMapDialog from "../../../../productManagement/ProductDetailMapDialog";

export interface DeliveryMessageProps {
    data?: TradeOrderData;
    onEdit?: (data: TradeOrderData) => void;
    onCancel?: (data: TradeOrderData) => void;
    onInitiate?: (data: TradeOrderData) => void;
    onDelete?: (data: TradeOrderData) => void;
    onClickOrderDetail?: (orderId: unknown) => void;
    deliveryVo?: DeliveryVo;
}

/** 提货明细展示履约字段，并按旧状态暴露修改、发起、取消和删除事件。 */
export default function DeliveryMessage({
    data = {},
    onEdit,
    onCancel,
    onInitiate,
    onDelete,
    onClickOrderDetail,
    deliveryVo
}: DeliveryMessageProps) {
    const state = Number(data.state);
    const orderState = Number(data.orderState);
    const orderCanOperate = ![4, 5].includes(orderState);
    const isNewData = data.newDataFlag == null || Number(data.newDataFlag) !== 0;
    const actions = [
        ["取消提货", onCancel, orderCanOperate && isNewData && [1, 2, 6].includes(state), "link"],
        ["修改", onEdit, orderCanOperate && (Number(data.newDataFlag) === 0 || [1, 2, 3, 6].includes(state)), "button"],
        ["发起提货", onInitiate, orderCanOperate && isNewData && state === 6, "button"],
        ["删除", onDelete, orderCanOperate && isNewData && state === 4, "button"]
    ] as const;
    return (
        <TradeOrderInfoPanel
            title="提货信息"
            data={data}
            actions={actions
                .filter(([, handler, visible]) => handler && visible)
                .map(([label, handler, , variant]) => ({
                    label,
                    onClick: () => handler?.(data),
                    variant: variant as "button" | "link"
                }))}
            fields={[
                {
                    label: "提货日期",
                    key: "scheduleDate",
                    value: row => String(row.scheduleDate || "--").slice(0, 10)
                },
                {
                    label: "结算金额",
                    key: "settlementAmount",
                    value: row => (row.settlementAmount == null ? "--" : `${row.settlementAmount} 元`)
                },
                {
                    label: "提货吨数",
                    key: "estimatedTon",
                    value: row => (row.estimatedTon == null ? "--" : `${row.estimatedTon} 吨`)
                },
                {
                    label: "结算单价",
                    key: "settlementUnitAmount",
                    value: row => (row.settlementUnitAmount == null ? "--" : `${row.settlementUnitAmount} 元/吨`)
                },
                { label: "关联运单", key: "transportOrderShipId" },
                { label: "船舶", key: "shipName" },
                {
                    label: "关联订单",
                    key: "orderId",
                    value: row => (
                        <button type="button" onClick={() => onClickOrderDetail?.(row.orderId)}>
                            {String(row.orderId || "--")}
                        </button>
                    )
                },
                { label: "订单类型", key: "orderType" },
                { label: "关联排期", key: "scheduleId" },
                { label: "收货人", key: "contacts" },
                { label: "收货联系方式", key: "cellphone" },
                {
                    label: "收货地址",
                    key: "address",
                    value: row => {
                        const address = deliveryVo?.delivery?.addressInfo;
                        return address?.geo ? (
                            <ProductDetailMapDialog
                                inline
                                location={{
                                    provinceCode: address.province,
                                    cityCode: address.city,
                                    regionCode: address.district,
                                    address: address.detailAddress,
                                    geo: address.geo
                                }}
                            />
                        ) : (
                            String(row.address || row.detailAddress || "--")
                        );
                    }
                }
            ]}
        />
    );
}
